import React, { useState, useEffect } from "react";
import { postData } from "../api/protectedApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransactionLayout from "../component/dashboard/TransactionLayout";
import { handleExportData } from "../utils/exportUtils";
import { callDataByEndpoint } from "../utils/dataUtils";

const DashboardTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const limit = 10;

  useEffect(() => {
    callDataByEndpoint("/user/deposit_transactions", {
      page: currentPage,
      limit,
      setData: setTransactions,
      setTotalCount,
      setIsLoading,
    });
  }, [currentPage]);

  const handleExport = (type) => {
    handleExportData({
      endpoint: "/user/deposit_transactions",
      columns,
      fallbackData: transactions,
      filename: "deposit_history",
      type,
      postDataFn: postData,
      toastFn: toast,
    });
  };

  const filteredTransactions = transactions.filter((t) => {
    const q = searchQuery.toLowerCase();
    return (
      t.tokenName?.toLowerCase().includes(q) ||
      t.from?.toLowerCase().includes(q) ||
      t.transactionHash?.toLowerCase().includes(q)
    );
  });

  const columns = [
    { key: "id", label: "ID" },
    { key: "amount", label: "Amount" },
    { key: "from", label: "From" },
    { key: "hash", label: "Hash" },
    { key: "currency", label: "Currency" },
    { key: "value", label: "Value" },
    { key: "date", label: "Date" },
  ];

  return (
    <TransactionLayout
      title="Deposit History"
      subtitle="Track, verify, and audit every incoming transaction across your gateway."
      searchQuery={searchQuery}
      onSearchChange={(q) => { setSearchQuery(q); setCurrentPage(1); }}
      searchPlaceholder="Search by currency, address, or hash..."
      onExport={handleExport}
      cardTitle="Recent Transactions"
      cardSubtitle="Real-time payment gateway ledger"
      columns={columns}
      data={filteredTransactions}
      isLoading={isLoading}
      emptyMessage="No transactions found."
      pagination={{
        currentPage,
        totalCount,
        limit,
        onPageChange: (page) => setCurrentPage(page),
      }}
    />
  );
};

export default DashboardTransactions;
